import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import ptBR from 'date-fns/locale/pt-BR';

import ThemeContextProvider from './ThemeContext'; // Importa o provider criado no passo 1

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  
    <ThemeContextProvider>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
        <App />
      </LocalizationProvider>
    </ThemeContextProvider>
 
);

reportWebVitals();

